import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { StoreModule } from "@ngrx/store";
import { AppCommonModule } from "src/app/common.module";
import { ConfirmDeactivateGuard } from "src/commons/guards";
import { reducers } from "./state/event-sponsorship.selectors";


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppCommonModule,
    StoreModule.forFeature('eventSponsorship', reducers),
  ],
  providers: [ConfirmDeactivateGuard],
  declarations: []
})
export class EventSponsorshipScreenModule { }